/**
 * @name Information
 * @function
 * @description 이용안내
 */

import { ImgText } from "../components/ImgText";
import AOS from "aos";
import "aos/dist/aos.css";
import { useEffect } from "react";

export const Information = (): JSX.Element => {
  useEffect(() => {
    AOS.init();
  });

  return (
    <div>
      <ImgText title="Information" text="예약 안내 및 환불 규정" />
      <div className="flex flex-row justify-center pb-6">
        <div className="p-3">
          <p
            className="text-xl sm:text-3xl font-bold mt-6 sm:mt-12"
            data-aos="fade-up"
            data-aos-duration="1000"
            data-aos-anchor-placement="center-bottom"
          >
            1. 예약안내
          </p>
          <div
            className="border-2 border-softpoint rounded-t-3xl mt-3 sm:mt-5"
            data-aos="fade-up"
            data-aos-duration="1000"
            data-aos-anchor-placement="center-bottom"
          >
            <table className=" w-full">
              <thead>
                <tr>
                  <th className="border-r-2  rounded-tl-3xl border-softpoint p-2 text-center bg-point text-white">
                    예약 방법
                  </th>
                  <th className="border-r-2  border-softpoint p-2 text-center bg-point text-white">
                    이용 시간
                  </th>
                  <th className="border-l-2  rounded-tr-3xl border-softpoint p-2 text-center bg-point text-white">
                    결제 방법
                  </th>
                </tr>
              </thead>
              <tbody>
                <tr>
                  <td className="border-r-2  border-softpoint p-2 text-center">
                    캠핏 어플을 통한 예약
                  </td>
                  <td className="border-r-2  border-softpoint p-2 text-center">
                    입실: 당일 13:00
                    <br />
                    퇴실: 익일 12:00
                  </td>
                  <td className="border-l-2 border-softpoint p-2 text-center">
                    캠핏 전용 계좌 확인
                  </td>
                </tr>
              </tbody>
            </table>
          </div>
          <ul
            className="mt-3 sm:mt-5 text-thickgray text-wrap"
            data-aos="fade-up"
            data-aos-duration="1000"
            data-aos-anchor-placement="center-bottom"
          >
            <li className="pb-2">- 예약문의: 010-8480-7114</li>
            <li className="pb-2">
              - 계좌 입금 시 예약 신청 후 3시간내로 전액을 입금하셔야 예약이
              완료됩니다.
            </li>
            <li className="pb-2">
              - 입금 대기시간이 경과되면 예약 신청이 자동 취소됩니다.
            </li>
          </ul>

          <p
            className="text-xl sm:text-3xl font-bold mt-6 sm:mt-12"
            data-aos="fade-up"
            data-aos-duration="1000"
            data-aos-anchor-placement="center-bottom"
          >
            2. 환불규정
          </p>
          <div
            className="border-2 border-softpoint rounded-t-3xl mt-3 sm:mt-5"
            data-aos="fade-up"
            data-aos-duration="1000"
            data-aos-anchor-placement="center-bottom"
          >
            <table className=" w-full">
              <thead>
                <tr>
                  <th className="border-r-2 rounded-tl-3xl border-softpoint p-2 text-center bg-point text-white">
                    이용일
                  </th>
                  <th className="rounded-tr-3xl p-2 text-center bg-point text-white">
                    수수료
                  </th>
                </tr>
              </thead>
              <tbody>
                <tr>
                  <td className="border-r-2 border-b-2 border-softpoint p-2 text-center">
                    8~10일 전까지 취소
                  </td>
                  <td className="border-b-2 border-softpoint p-2 text-center">
                    100% 환불
                  </td>
                </tr>
                <tr>
                  <td className="border-r-2 border-b-2 border-softpoint p-2 text-center">
                    6~7일 전까지 취소
                  </td>
                  <td className="border-b-2 border-softpoint p-2 text-center">
                    80% 환불
                  </td>
                </tr>
                <tr>
                  <td className="border-r-2 border-b-2 border-softpoint p-2 text-center">
                    4~5일 전까지 취소
                  </td>
                  <td className="border-b-2 border-softpoint p-2 text-center">
                    60% 환불
                  </td>
                </tr>
                <tr>
                  <td className="border-r-2 border-b-2 border-softpoint p-2 text-center">
                    2~3일 전까지 취소
                  </td>
                  <td className="border-b-2 border-softpoint p-2 text-center">
                    40% 환불
                  </td>
                </tr>
                <tr>
                  <td className="border-r-2 border-b-2 border-softpoint p-2 text-center">
                    1일 전까지 취소
                  </td>
                  <td className="border-b-2 border-softpoint p-2 text-center">
                    10% 환불
                  </td>
                </tr>
                <tr>
                  <td className="border-r-2  border-softpoint p-2 text-center">
                    당일 취소
                  </td>
                  <td className=" p-2 text-center">환불 불가</td>
                </tr>
              </tbody>
            </table>
          </div>
          <ul
            className="mt-3 sm:mt-5 text-thickgray text-wrap"
            data-aos="fade-up"
            data-aos-duration="1000"
            data-aos-anchor-placement="center-bottom"
          >
            <li className="pb-2">
              ※ 환불은 온라인 및 유선전화로 가능하며, 환불금은 취소 후 7일
              이내에 처리됩니다.
            </li>
            <li className="pb-2">
              ※ 환불 전 예약 일자별 환불 수수료를 반드시 확인하시고
              진행바랍니다.
            </li>
          </ul>
          <p
            className="text-xl sm:text-3xl font-bold mt-6 sm:mt-12"
            data-aos="fade-up"
            data-aos-duration="1000"
            data-aos-anchor-placement="center-bottom"
          >
            3. 이용수칙
          </p>
          <ul
            className="mt-3 sm:mt-5 text-thickgray text-wrap"
            data-aos="fade-up"
            data-aos-duration="1000"
            data-aos-anchor-placement="center-bottom"
          >
            <li className="pb-2">- 입실 및 퇴실시간을 준수하여야 합니다.</li>
            <li className="pb-2">
              - 캠핑장 이용기준 데크당 4인기준을 준수하고, 초과인원 추가비가
              발생됩니다.
            </li>
            <li className="pb-2">
              - 캠핑장 내 반려동물의 입장은 불가능합니다.
            </li>
            <li className="pb-2">
              - 캠핑장의 출입은 반드시 정해진 곳을 이용하시고, 관리자의 안내에
              따라 주시기 바랍니다.
            </li>
            <li className="pb-2">- 취사는 지정된 장소에서만 할 수 있습니다.</li>
            <li className="pb-2">
              - 캠핑장내 차량은 서행하시고, 공회전 및 세차를 금지합니다.
            </li>
            <li className="pb-2">
              - 다른 이용객 및 주민들에게 피해가 되는 고성방가, 폭죽놀이등은
              금지합니다.
            </li>
            <li className="pb-2">
              - 쓰레기 및 폐수는 지정된 장소에 종류별로 분리배출하여 주시기
              바랍니다.
            </li>
            <li className="pb-2">
              - 흡연은 지정된 장소에서 해주시기 바랍니다.
            </li>
            <li className="pb-2">
              - 이용자의 소유물에 대한 유실 또는 피해가 없도록 이용자 본인이
              책임지고 관리하여야 합니다.
            </li>
            <li className="pb-2">
              - 캠핑장 시설에 피해를 입힌 경우 당사자에게 비용이 청구됩니다.
            </li>
            <li className="pb-2">
              - 캠핑장내 어떤 행위든 타인에게 불편함을 끼칠경우 1차 경고, 2차
              강제퇴장 시킬 수 있습니다.
            </li>
          </ul>
        </div>
      </div>
    </div>
  );
};
